import * as actionTypes from "./categoryActionType";
import axios from "axios";
import { checkError, apiTimeout } from "./../error";
const { REACT_APP_API_URL } = process.env;

export const fetchCategory = () => {
  return (dispatch) => {
    dispatch(fetchCategoryInit());
    apiTimeout(axios.get(`${REACT_APP_API_URL}/category/active`))
      .then((response) => {
        dispatch(fetchCategorySuccess(response.data.data));
      })
      .catch(function (error) {
        dispatch(fetchCategoryFailure());
        checkError(error);
      });
  };
};

export const fetchCategoryInit = () => ({
  type: actionTypes.FETCH_CATEGORY,
});

export const fetchCategoryFailure = () => ({
  type: actionTypes.FETCH_CATEGORY_FAILURE,
});

export const fetchCategorySuccess = (data) => ({
  type: actionTypes.FETCH_CATEGORY_SUCCESS,
  payload: { data },
});
